import { render, staticRenderFns } from "./ComprasDiretasDisponiveisTabela.vue?vue&type=template&id=78adf006&scoped=true"
import script from "./ComprasDiretasDisponiveisTabela.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasDisponiveisTabela.vue?vue&type=script&lang=js"
import style0 from "./ComprasDiretasDisponiveisTabela.vue?vue&type=style&index=0&id=78adf006&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78adf006",
  null
  
)

export default component.exports